"use strict";
exports.__esModule = true;
exports.GdcVisualizationObject = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * @public
 */
var GdcVisualizationObject;
(function (GdcVisualizationObject) {
    function isObjUriQualifier(objQualifier) {
        return !isEmpty_1["default"](objQualifier) && objQualifier.uri !== undefined;
    }
    GdcVisualizationObject.isObjUriQualifier = isObjUriQualifier;
    function isObjIdentifierQualifier(objQualifier) {
        return !isEmpty_1["default"](objQualifier) && objQualifier.identifier !== undefined;
    }
    GdcVisualizationObject.isObjIdentifierQualifier = isObjIdentifierQualifier;
    function isVisualization(obj) {
        return !isEmpty_1["default"](obj) && obj.visualizationObject !== undefined;
    }
    GdcVisualizationObject.isVisualization = isVisualization;
    function isMeasure(bucketItem) {
        return !isEmpty_1["default"](bucketItem) && bucketItem.measure !== undefined;
    }
    GdcVisualizationObject.isMeasure = isMeasure;
    function isAttribute(bucketItem) {
        return !isEmpty_1["default"](bucketItem) && bucketItem.visualizationAttribute !== undefined;
    }
    GdcVisualizationObject.isAttribute = isAttribute;
    function isMeasureDefinition(definition) {
        return !isEmpty_1["default"](definition) && definition.measureDefinition !== undefined;
    }
    GdcVisualizationObject.isMeasureDefinition = isMeasureDefinition;
    function isArithmeticMeasureDefinition(definition) {
        return (!isEmpty_1["default"](definition) &&
            definition.arithmeticMeasure !== undefined);
    }
    GdcVisualizationObject.isArithmeticMeasureDefinition = isArithmeticMeasureDefinition;
    function isPopMeasureDefinition(definition) {
        return (!isEmpty_1["default"](definition) && definition.popMeasureDefinition !== undefined);
    }
    GdcVisualizationObject.isPopMeasureDefinition = isPopMeasureDefinition;
    function isPreviousPeriodMeasureDefinition(definition) {
        return (!isEmpty_1["default"](definition) &&
            definition.previousPeriodMeasure !== undefined);
    }
    GdcVisualizationObject.isPreviousPeriodMeasureDefinition = isPreviousPeriodMeasureDefinition;
    function isAttributeFilter(filter) {
        return (!isEmpty_1["default"](filter) &&
            (filter.positiveAttributeFilter !== undefined ||
                filter.negativeAttributeFilter !== undefined));
    }
    GdcVisualizationObject.isAttributeFilter = isAttributeFilter;
    function isDateFilter(filter) {
        return (!isEmpty_1["default"](filter) &&
            (filter.absoluteDateFilter !== undefined ||
                filter.relativeDateFilter !== undefined));
    }
    GdcVisualizationObject.isDateFilter = isDateFilter;
    function isPositiveAttributeFilter(filter) {
        return !isEmpty_1["default"](filter) && filter.positiveAttributeFilter !== undefined;
    }
    GdcVisualizationObject.isPositiveAttributeFilter = isPositiveAttributeFilter;
    function isNegativeAttributeFilter(filter) {
        return !isEmpty_1["default"](filter) && filter.negativeAttributeFilter !== undefined;
    }
    GdcVisualizationObject.isNegativeAttributeFilter = isNegativeAttributeFilter;
    function isMeasureValueFilter(filter) {
        return !isEmpty_1["default"](filter) && filter.measureValueFilter !== undefined;
    }
    GdcVisualizationObject.isMeasureValueFilter = isMeasureValueFilter;
    function isRankingFilter(filter) {
        return !isEmpty_1["default"](filter) && filter.rankingFilter !== undefined;
    }
    GdcVisualizationObject.isRankingFilter = isRankingFilter;
    function isAbsoluteDateFilter(filter) {
        return !isEmpty_1["default"](filter) && filter.absoluteDateFilter !== undefined;
    }
    GdcVisualizationObject.isAbsoluteDateFilter = isAbsoluteDateFilter;
    function isRelativeDateFilter(filter) {
        return !isEmpty_1["default"](filter) && filter.relativeDateFilter !== undefined;
    }
    GdcVisualizationObject.isRelativeDateFilter = isRelativeDateFilter;
    function isLocalIdentifierQualifier(objectQualifier) {
        return (!isEmpty_1["default"](objectQualifier) &&
            objectQualifier.localIdentifier !== undefined);
    }
    GdcVisualizationObject.isLocalIdentifierQualifier = isLocalIdentifierQualifier;
    function isComparisonCondition(condition) {
        return !isEmpty_1["default"](condition) && condition.comparison !== undefined;
    }
    GdcVisualizationObject.isComparisonCondition = isComparisonCondition;
    function isRangeCondition(condition) {
        return !isEmpty_1["default"](condition) && condition.range !== undefined;
    }
    GdcVisualizationObject.isRangeCondition = isRangeCondition;
})(GdcVisualizationObject = exports.GdcVisualizationObject || (exports.GdcVisualizationObject = {}));
//# sourceMappingURL=GdcVisualizationObject.js.map